"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _eventBus = require("@/helpers/event-bus.js");

var _vuex = require("vuex");

var _LotDetail = _interopRequireDefault(require("./components/LotDetail"));

var _AffaireTotaux = _interopRequireDefault(require("./components/AffaireTotaux"));

var _Modele = _interopRequireDefault(require("./components/Modele"));

var _Workflow = _interopRequireDefault(require("@/components/Workflow"));

var CONST = _interopRequireWildcard(require("@/helpers/constantes"));

var apiSociete = _interopRequireWildcard(require("@/api/societe"));

require("@/mixins/workflow");

var _moment = _interopRequireDefault(require("moment"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = {
  name: 'VenteInitiale',
  components: {
    LotDetail: _LotDetail.default,
    AffaireTotaux: _AffaireTotaux.default,
    Modele: _Modele.default,
    Workflow: _Workflow.default
  },
  data: function data() {
    return {
      refresh: 0,
      CONST: CONST,
      listeDeboursesIndirects: [],
      userCanDoAction: false
    };
  },
  beforeMount: function () {
    var _beforeMount = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this = this;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getWorkflow('vente_initiale').then(function () {
                _this.userCanDoAction = _this.isUserCanDoAction(CONST.AFFAIRE.ETAPE.VENTE_INITIALE.value, 'vente_initiale');
              });

            case 2:
              // recherche des déboursés indirects configurés au niveau de la societe
              apiSociete.getById(this.affaire.affaire.id_societe).then(function (results) {
                if (results && results.length > 0) {
                  if (results[0].deboursesIndirects) {
                    var deboursesIndirects = results[0].deboursesIndirects && results[0].deboursesIndirects.length > 0 ? JSON.parse(results[0].deboursesIndirects) : [];

                    var _iterator = _createForOfIteratorHelper(deboursesIndirects),
                        _step;

                    try {
                      for (_iterator.s(); !(_step = _iterator.n()).done;) {
                        var deb = _step.value;

                        _this.listeDeboursesIndirects.push({
                          'value': deb.titre_debourseIndirect,
                          'id_debourseIndirect': deb.id_debourseIndirect,
                          'show': true
                        });
                      }
                    } catch (err) {
                      _iterator.e(err);
                    } finally {
                      _iterator.f();
                    }
                  }
                }
              });

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeMount() {
      return _beforeMount.apply(this, arguments);
    }

    return beforeMount;
  }(),
  mounted: function mounted() {
    _eventBus.EventBus.$emit('REFRESH_CALCULS');

    this.refresh++;
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['user']), {
    affaire: function affaire() {
      return this.$store.getters.affaire;
    }
  }),
  methods: {
    periodeGestion: function periodeGestion() {
      _moment.default.locale('fr');

      var periode = (0, _moment.default)(this.$store.getters.affaire.YYYYMMmoins1, 'YYYYMM').format('MMMM YYYY');
      var isValidDate = (0, _moment.default)(this.$store.getters.affaire.YYYYMMmoins1, 'YYYYMM', true).isValid();
      return this.$store.getters.affaire.currentGestMensYYYYMM && isValidDate ? 'Gestion de ' + periode : '';
    },
    // appel à partir de l'icone pour passer le lot en mode edition
    handleModeEdit: function handleModeEdit(lot) {
      // envoi le signal pour passer le lot en mode edition, traité dans le composant LotDetail
      _eventBus.EventBus.$emit('EDIT_LOT', lot.id);
    },
    // appel à partir du bouton pour ajouter un nouveau lot
    handleNew: function handleNew() {
      var _this2 = this;

      this.$prompt('Libellé', 'Ajouter un lot', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Annuler',
        inputValidator: function inputValidator(value) {
          return value !== null && value !== '';
        },
        inputErrorMessage: 'Champ obligatoire',
        closeOnClickModal: false
      }).then(function (_ref) {
        var value = _ref.value;
        var lot = {
          id_affaire: _this2.affaire.affaire.id,
          libelle: value,
          ordre: _this2.affaire.lots.length + 1
        };

        _this2.action('insertLot', lot);
      });
    },
    // appel à partir de l'icone pour éditer le lot
    handleEdit: function handleEdit(currentLot) {
      var _this3 = this;

      this.$prompt('Libellé', 'Modifier un lot', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Annuler',
        inputValue: currentLot.libelle,
        inputValidator: function inputValidator(value) {
          return value !== '';
        },
        inputErrorMessage: 'Champ obligatoire',
        closeOnClickModal: false
      }).then(function (_ref2) {
        var value = _ref2.value;
        var lot = {
          id: currentLot.id,
          id_affaire: currentLot.id_affaire,
          libelle: value,
          ordre: currentLot.ordre
        };

        _this3.action('updateLot', lot);
      });
    },
    // appel à partir de l'icone de suppression d'un lot
    handleDelete: function handleDelete(currentLot, index) {
      var _this4 = this;

      var lotsDetail = this.$store.getters.affaire.lotsDetail.filter(function (x) {
        return x.id_lot === currentLot.id;
      });

      if (lotsDetail.length > 0) {
        this.$alert('Ce lot ne peut pas être supprimé car il comporte des lignes de détail. Veuillez d\'abord supprimer les lignes de ce lot', 'Suppression lot', {
          confirmButtonText: 'OK',
          type: 'error'
        });
      } else {
        this.$confirm('Voulez-vous supprimer ce lot ?', 'Confirmation', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning',
          closeOnClickModal: false
        }).then(function () {
          var lot = {
            id: currentLot.id
          };

          _this4.action('deleteLot', lot);

          _eventBus.EventBus.$emit('MODE_EDIT', false);
        });
      }
    },
    // execution des actions en base de données: insertLot, deleteLot, updateLot
    action: function action(_action, lot) {
      var _this5 = this;

      // console.log(action, lot)
      this.$loader(true);
      this.$store.dispatch('affaire/' + _action, lot).then(function (results) {
        _this5.$store.dispatch('affaire/setLotDetail', lot).then(function () {
          _eventBus.EventBus.$emit('REFRESH_CALCULS');

          _this5.$loader(false);

          _this5.refresh++;
        });
      }).catch(function (error) {
        _this5.$message(error);

        _this5.$loader(false);
      });
    },
    // ================================
    handleBeforeToValidate: function handleBeforeToValidate(workflow) {
      var _this6 = this;

      return new Promise(function (resolve, reject) {
        // ===============================================================
        // vérification 1: on vérifie s'il existe des lignes de lots de détail ont été saisies
        // ===============================================================
        if (_this6.affaire.lotsDetail && _this6.affaire.lotsDetail.length === 0) {
          _this6.$alert('Aucune ligne de lot saisie', 'Validation impossible', {
            confirmButtonText: 'OK',
            type: 'error'
          }).then(function () {
            reject(new Error());
          });
        } else {
          // ===============================================================
          // vérification 2: on vérifie que toutes les valeurs de déboursés indirects ont été sélectionnées avant de valider la demande
          // ===============================================================
          // - liste des déboursés indirects configurés dans l'administration > sociétés
          var listeRefFlagIdent = _this6.listeDeboursesIndirects.map(function (x) {
            return x.id_debourseIndirect;
          }); // - liste des déboursés indirects sélectionnés sur l'écran de vente initial


          var listeLotFlagIdent = _this6.affaire.lotsDetail.map(function (x) {
            return x.id_debourseIndirect;
          }).filter(function (x) {
            return x !== 0;
          });

          var listeUniqFlagIdent = _toConsumableArray(new Set(listeLotFlagIdent)); // - comparaison des 2 listes pour voir si tous les déboursés indirects ont été sélectionnés


          var compareArray = listeRefFlagIdent.reduce(function (a, b) {
            return a && listeUniqFlagIdent.includes(b);
          }, true);

          if (!compareArray) {
            _this6.$alert('Saisie des lots incomplète. Toutes les valeurs de déboursés indirects n\'ont pas été sélectionnées', 'Demande de validation impossible', {
              confirmButtonText: 'OK',
              type: 'error'
            }).then(function () {
              reject(new Error());
            });
          } else {
            resolve();
          }
        }
      });
    },
    handleBeforeValidated: function handleBeforeValidated(workflow) {
      return this.handleBeforeToValidate(workflow);
    }
  }
};
exports.default = _default;